import IconEye from 'approot/shared/icons/icon-eye';
import IconEyeHide from 'approot/shared/icons/icon-eye-hide';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import { useActivityBuilderPresentContext } from '../present/activity-builder-present.context';

const ClassroomAnswerStudentVisibility = () => {
  const { isStudentNamesVisible, setIsStudentNamesVisible } =
    useActivityBuilderPresentContext();

  return (
    <TooltipWrapper
      multiline
      hoverText="Show or hide student names to identify who completed each activity."
    >
      <SecondaryButton
        type="button"
        $withIcon
        $isSmall
        onClick={() => setIsStudentNamesVisible(!isStudentNamesVisible)}
      >
        {isStudentNamesVisible ? (
          <IconEyeHide width={24} height={24} />
        ) : (
          <IconEye width={24} height={24} />
        )}
        <span>
          {isStudentNamesVisible ? 'Hide Student Names' : 'Show Student Names'}
        </span>
      </SecondaryButton>
    </TooltipWrapper>
  );
};

export default ClassroomAnswerStudentVisibility;
